import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { LoyaltyChart, LoyaltySankeyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { ClusterModel } from '../../../../services/analytics/analytics.model';

@Component({
  selector: 'app-customer-evolution',
  templateUrl: './customer-evolution.component.html',
  styleUrls: ['./customer-evolution.component.css']
})
export class CustomerEvolutionComponent implements OnInit {

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];

  translations: any;

  migrationFlowChart: LoyaltySankeyChart;

  clusterList: ClusterModel[] = [];
  startClusterList: ClusterModel[] = [];
  destClusterList: ClusterModel[] = [];

  public data: QFilterModel;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.initCharts();

    this.svcAnalytics.getClusterList().subscribe((clusterList) => {
      this.clusterList = clusterList;
    });
  }

  initCharts() {
    this.migrationFlowChart = (new LoyaltySankeyChart());
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
    // chart.instance.title.text = this.translations.migrationFlow;
  }

  setChartSankeyInstance(chart: LoyaltySankeyChart, chartInstance) {
    chart.instance = chartInstance;
    // chart.instance.title.text = this.translations.migrationFlow;
  }

  clickStartSegment(startCluster) {
    const index = this.startClusterList.indexOf(startCluster);
    if (index < 0){
      this.startClusterList.push(startCluster);
    } else {
      this.startClusterList.splice(index, 1);
    }
  }

  clickDestSegment(destCluster) {
    const index = this.destClusterList.indexOf(destCluster);
    if (index < 0){
      this.destClusterList.push(destCluster);
    } else {
      this.destClusterList.splice(index, 1);
    }
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;

    let queryParam = '';
    if (this.startClusterList.length > 0 || this.destClusterList.length > 0) {
      queryParam += '?';
      if (this.startClusterList.length > 0) {
        queryParam += 'by_cluster_prev=' + this.startClusterList.map(c => c.code).join() + '&';
      }

      if(this.destClusterList.length > 0) {
        queryParam += 'by_cluster_last=' + this.destClusterList.map(c => c.code).join();
      }
    }

    // questo purtroppo è l'unico workaround al problema della duplicazione delle serie per il sankey.
    this.migrationFlowChart = new LoyaltySankeyChart();

    // todo: parametri a loadSankeyChart
    this.chartsService.loadSankeyChart(this.migrationFlowChart, 'customers.Q070', data, this.indicatorService, this.translate, queryParam);

  }

  resetData() {
    this.data = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-evolution/customer-evolution.component.ts